import {
  FinancialHighlightsModel,
  ReportSection,
  ReportSectionConfigurationBase,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';

export class ActivitiesConfiguration extends ReportSectionConfigurationBase {
  typeName = 'ActivitiesConfiguration';
  nodataLocalizationKeyName = 'activities';
  readonly reportSection = ReportSection.FinancialHighlights;
  readonly applicableReportTypes = [ReportType.Contact, ReportType.Institution];
  readonly reportViewModelSections = [ReportViewModelSection.InvestorProfile_FinancialHighlights];
  minSize = 1;
  maxSize = 2;
  defaultSize = 1;
  readonly availableDataSections = [
    {
      name: 'activitiesLastDateMet',
      displayName: 'Last Date Met',
      isSelected: true,
      canConfigure: true
    },
    {
      name: 'activitiesWithInstitutionCount',
      displayName: '# Activities with Institution',
      isSelected: true,
      canConfigure: true
    },
    {
      name: 'activitiesWithContactCount',
      displayName: '# Activities with Contact',
      isSelected: true,
      canConfigure: true
    }
  ];

  get name(): string {
    if (this.appliedReportType === ReportType.Contact) {
      return 'contactActivities';
    } else if (this.appliedReportType === ReportType.Institution) {
      return 'institutionActivities';
    } else {
      throw new Error('Report Type not supported');
    }
  }

  get displayName(): string {
    if (this.appliedReportType === ReportType.Contact || this.appliedReportType === ReportType.Institution) {
      return 'Activities';
    } else {
      throw new Error('Report Type not supported');
    }
  }
}

export interface ActivitiesData {
  [ReportViewModelSection.InvestorProfile_FinancialHighlights]: FinancialHighlightsModel;
}
